import React from 'react';
import { Box, Pagination } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { TODAY } from '@epi-constants/downloadReports';

import { CardTypeSelectionRange } from './CardTypeSelectionRange/CardTypeSelectionRange';
import { TransactionsCalendarRange } from '../TransactionsCalendarRange';
import { TransactionsSelectRange } from '../TransactionsSelectRange';
import { CardOrdersTable } from './CardOrdersTable';
import { useOrders } from './hooks/useOrders';

export const CardOrders = () => {
  const { t } = useTranslation();
  const { gray10 } = useTheme();
  const {
    cardType,
    setCardType,
    orders,
    page,
    totalPages,
    isLoading,
    isFetching,
    showCalendar,
    setShowCalendar,
    timePeriodType,
    from,
    to,
    setFrom,
    setTo,
    setPage,
    setTimePeriodType
  } = useOrders();

  const closeTimePeriod = () => {
    setShowCalendar(false);
  };

  return (
    <Box marginTop="40px">
      <Box
        pb={5}
        borderBottom={`1px solid ${gray10}`}
        my={5}
        flexDirection="row"
        display="flex"
        flex="1"
      >
        <TransactionsSelectRange
          setPage={setPage}
          setShowCalendar={setShowCalendar}
          timePeriodType={timePeriodType}
          setTimePeriodType={setTimePeriodType}
          from={from}
          setFrom={setFrom}
          to={to}
          setTo={setTo}
        />
        <CardTypeSelectionRange
          cardTypeId={cardType}
          setPage={setPage}
          setCardTypeId={setCardType}
        />
      </Box>

      {showCalendar && (
        <TransactionsCalendarRange
          isOpen={showCalendar}
          closeAction={closeTimePeriod}
          disabledCustomDates={{ after: TODAY }}
          from={from}
          to={to}
          setFrom={setFrom}
          setTo={setTo}
        />
      )}
      <CardOrdersTable
        ordersHistory={orders}
        isLoading={isLoading || isFetching}
      />
      <Box mt={5}>
        <Pagination
          prevBtnText={t('shared.pagination.previous')}
          nextBtnText={t('shared.pagination.next')}
          page={page}
          count={totalPages}
          onChangePage={setPage}
        />
      </Box>
    </Box>
  );
};
